import(/* webpackMode: "eager" */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\node_modules\\next\\dist\\client\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\node_modules\\next\\dist\\client\\script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\app\\layanan\\[slug]\\CTASection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\app\\layanan\\[slug]\\FAQSectionClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\app\\layanan\\[slug]\\PricingSectionClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\CompanyLogosSliderClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\HeroDecorClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\WORK\\ahli SEO\\Code\\ahliseo-frontend\\src\\components\\common\\TestimonialsClient.tsx");
